import BaseComponent from '@/components/base';
import { getStyle } from './style.js';

export default class ProductImage extends BaseComponent {
  get imageSources() {
    return JSON.parse(this.getAttribute('image-sources') || '{}');
  }

  get imageAlt() {
    return this.getAttribute('image-alt') || 'Product Image';
  }

  render() {
    return `
      ${getStyle(this.isSmall)}
      <picture>
        <source
          media="(max-width: 600px)"
          srcset="${this.imageSources?.small}"
        >
        <source
          media="(min-width: 601px) and (max-width: 1023px)"
          srcset="${this.imageSources?.medium}"
        >
        <source
          media="(min-width: 1024px)"
          srcset="${this.imageSources?.large}"
        >
        <img
          src="${this.imageSources?.large}"
          alt="${this.imageAlt}"
        >
      </picture>
  `;
  }
}
